import { useCallback } from 'react';

interface PopupDownloadOptions {
    path: string;
    key: string;
    windowName?: string;
    width?: number;
    height?: number;
    payloadType?: string;
    payloadData: any;
}

interface PopupLoadOptions {
    path: string;
    windowName?: string;
    width?: number;
    height?: number;
    expectedType: string;
    onReceive: (payload: any) => void;
}

export function usePopup() {
    const openDownloadPopup = useCallback(({
        path,
        key,
        windowName = "파일 다운로드",
        width = 420,
        height = 220,
        payloadType = "ESTIMATE_DATA",
        payloadData
    }: PopupDownloadOptions) => {
        const url = `${window.location.origin}${path}?key=${key}`;
        
        const popup = window.open(url, windowName, `width=${width},height=${height}`);

        if (!popup) {
            alert("팝업이 차단되었습니다. 브라우저 팝업 허용 후 다시 시도해주세요.");
            return;
        }

        const onReady = (e: MessageEvent) => {
            if (e.source !== popup || (e.data as any)?.type !== "POPUP_READY") return;
            popup.postMessage({ type: payloadType, payload: payloadData }, "*");
            cleanup();
        };
        const cleanup = () => {
            window.removeEventListener("message", onReady);
            clearInterval(pollId);
        };
        window.addEventListener("message", onReady);
        const pollId = setInterval(() => {
            if (popup.closed) cleanup();
        }, 500);
    }, []);

    const openLoadPopup = useCallback(({
        path,
        windowName = "데이터 불러오기",
        width = 1050,
        height = 720,
        expectedType,
        onReceive
    }: PopupLoadOptions) => {
        const url = `${window.location.origin}${path}`;
        const popup = window.open(url, windowName, `width=${width},height=${height}`);

        if (!popup) {
            alert("팝업이 차단되었습니다. 브라우저 팝업 허용 후 다시 시도해주세요.");
            return;
        }

        const onMsg = (e: MessageEvent) => {
            if (e.origin !== window.location.origin) return;
            if (e.source !== popup) return;

            const data = e.data as any;
            if (data?.type === expectedType) {
                onReceive(data.payload);
                cleanup();
            }
        };
        const cleanup = () => {
            window.removeEventListener("message", onMsg);
            clearInterval(pollId);
        };
        window.addEventListener("message", onMsg);
        const pollId = setInterval(() => {
            if (popup.closed) cleanup();
        }, 500);
    }, []);

    return { openDownloadPopup, openLoadPopup };
}
